<template>
    <div>
        <span
            v-for="(p, index) in CPosition"
            :key="p">
            <span class="font-bold">
                {{ p.nodeTypeName }}
            </span>
            - {{ p.nodeLocationName }}
            <span v-if="index !== CPosition.length - 1">
                ->
            </span>
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CPosition = computed(() => {
  const journey = params?.value?.data || {}
  const { positionsAndWaitingTasks } = journey
  if (Array.isArray(positionsAndWaitingTasks)) {
    return positionsAndWaitingTasks.slice(journey.stageIndexBegin || 0, (journey.stageIndexEnd || 0) + 1)
  }
  return []
})
</script>

<style scoped></style>
